import type { UseQueryOptions } from "@tanstack/react-query";

/**
 * Merges user-provided query options with additional enabled conditions
 * Both conditions must be true for the query to run
 */
export function mergeQueryOptions<TData>(
  options: Omit<UseQueryOptions<TData>, "queryKey" | "queryFn"> = {},
  additionalEnabledConditions: boolean[]
): Omit<UseQueryOptions<TData>, "queryKey" | "queryFn"> {
  const userEnabled = "enabled" in options ? options.enabled : true;
  const allConditions = [userEnabled, ...additionalEnabledConditions];
  
  return {
    ...options,
    enabled: allConditions.every(condition => condition === true),
  };
}